import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@tango/app/shared';
import { LockedPageComponent } from './locked-page.component';
import { LockedPageRoutingModule } from './locked-page.routing';

@NgModule({
  imports: [CommonModule, SharedModule, LockedPageRoutingModule],
  declarations: [LockedPageComponent],
})
export class LockedPageModule {}
